import CardBuilder from './CardBuilder.jsx';

export const cssBEM = 'cardBuilder';
export default CardBuilder;
